import React from "react";

const MainMenu = () => {
	return <div></div>;
};

export default MainMenu;
